import { BybButton } from "@Components/common/byb-ds";
import HapticButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { AppContext } from "@Context/common/general/context";
import { useCareerContext } from "@Context/game/career/career-context";
import useI18n from "@i18n";
import { Stack, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import CareerActionButtons from "./career-action-buttons";
import { CareerInfoPanel } from "./styled-components";

const CareerStatusInfo = () => {
  const theme = useTheme();
  const { state } = useContext(AppContext);
  const { i18n } = useI18n();
  const { t } = useTranslation("VR");
  const { league, division } = useCareerContext();

  if (!league || !division) return null;

  const handleWatchVideo = () => {
    const videoId = division.video_id;
    if (!videoId) return;
    state.app.events.showVideo.emit({ videoId });
  };

  return (
    <CareerInfoPanel>
      <Stack flex={0.7} spacing={3} justifyContent="center">
        <Typography variant="textLg500" color="dsNeutral.v300">
          {i18n("division.specific", { division: division.name })} • {i18n(`league.${league.name}.name`)}
        </Typography>
        <Typography variant="text5xl700" color="dsBase.v200">
          {i18n("career.label")}
        </Typography>
        <Stack spacing={theme.spacing(2)} width="100%">
          {division.briefing ? (
            <Typography variant="text1xl500" color="dsNeutral.v300">
              {t(`career.message.briefing.${league.name.toLowerCase()}.${division.name}`)}
            </Typography>
          ) : (
            <Typography variant="text1xl500" color="dsNeutral.v300">
              {i18n("career.status.no.briefing")}
            </Typography>
          )}
        </Stack>
      </Stack>

      <Stack flex={0.3} spacing={4} justifyContent="center" width="100%" alignItems="center">
        <CareerActionButtons />
        {division.video_id && (
          <HapticButtonWrapper>
            <BybButton size="large" color="secondary" onClick={handleWatchVideo} sx={{ width: "fit-content" }}>
              {i18n("career.watch.video")}
            </BybButton>
          </HapticButtonWrapper>
        )}
      </Stack>
    </CareerInfoPanel>
  );
};

export default CareerStatusInfo;
